import BaseButton from "base/BaseButton";
import React from "react";

const RecipeSortByNumOfSteps = ({ recipes, onNumOfStepsSort }) => {
  const sortByNumberOfSteps = () => {
    let copy = [...recipes];
    copy.sort((a, b) => a.steps.length - b.steps.length);
    onNumOfStepsSort(copy);
  };

  return (
    <BaseButton
      widthClass="w-100"
      buttonText="Recipe Steps"
      handleClick={sortByNumberOfSteps}
    />
  );
};

export default RecipeSortByNumOfSteps;
